<template>
  <GfrTitle :class="['app-docs-title']" :level="1" :placement="$route.params.lang === 'ar' ? 'right' : 'left'">
    <slot />
  </GfrTitle>
</template>
<style lang="scss" scoped>
.app-docs-title {
  @apply relative ltr:pl-5 rtl:pr-5 text-[34px] font-bold leading-[46px];
  @apply before:absolute ltr:before:left-0 rtl:before:right-0 before:top-3 before:h-6 before:w-1.5 before:bg-primary before:content-[''];
}
</style>
